import React, { useEffect, useState } from "react";
import constants from "../utilities/constants";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Modal from "./LoginModal";
import {
  clearAuthModalType,
  getAuthModalType,
  loginModalAction,
} from "../redux/action/authAction";
import { getPersionalData } from "../redux/action/myAccountAction";
import {
  getHeaderdata,
  countryselect,
  getHomepagedata,
  daily_metal_price_currency,
} from "../redux/action/homeAction";
import Search from "./Search";
import PopupModal from "./PopupModal";
import Authenticatemodal from "../screens/Modalscreens/Authenticatemodal";
import config from "../utilities/config";
import { getHomepagenotification } from "../redux/action/homeAction";
import { addWishlistWithLogin } from "../redux/action/myAccountAction";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

import "../styles/styles.css";

// import required modules
import { Grid, Pagination, Autoplay } from "swiper/modules";
import {
  activeMenuMatchUrl,
  capitalizeFirstLetter,
  findMatchingSubmenu,
} from "../utilities/helper";
import SeoHelmet from "./SeoHelmet";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userProfile_id } = useSelector((state) => state.authReducer);
  const authModalopen = useSelector((state) => state.authReducer.authModalopen);
  const { addwishlistwithoutloginsuccess } = useSelector(
    (state) => state.myAccountReducer
  );
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [userName, setuserName] = useState("");
  const [activeMenuLink, setactiveMenuLink] = useState(null);
  const [clickedMenuItem, setClickedMenuItem] = useState(null);

  const {
    dailyMetalPriceSuccess, // all country names
    selectedcountrySuccess, //country chosen by user
  } = useSelector((state) => state.homeReducer);
  const {
    //persionalinformation

    persionalInformationDataSuccess,

    //wishlist

    wishListDataSuccess,
  } = useSelector((state) => state.myAccountReducer);
  const { cart_items_numberResponseSuccess } = useSelector(
    (state) => state.cartNumberReducer
  );
  const cartItemsProductInfo =
    cart_items_numberResponseSuccess?.nodes[0]
      ?.shoppingCartItemsByShoppingCartId?.nodes?.length || 0;
  const { homeNotificationResponseSuccess } = useSelector(
    (state) => state.homeNotificationReducer
  );

  const { headerResponseSuccess, headerResponseSuccessMobile } = useSelector(
    (state) => state.headerReducer
  );

  config.logGeneral &&
    console.log("headerResponseSuccessMobile", headerResponseSuccessMobile);

  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    if (userProfile_id === null || !userProfile_id) {
      if (
        window.location.href.includes("account") ||
        window.location.href.includes("checkout")
      ) {
        dispatch(getAuthModalType(constants.Login));
      } else {
        dispatch(clearAuthModalType());
      }
    }
    if (userProfile_id) {
      if (addwishlistwithoutloginsuccess?.length > 0) {
        dispatch(
          addWishlistWithLogin(
            userProfile_id,
            addwishlistwithoutloginsuccess[0]?.product_sku,
            addwishlistwithoutloginsuccess[0]?.product_id
          )
        );
      }
      // setTimeout(() => dispatch(getPersionalData(userProfile_id)),100);
      dispatch(getPersionalData(userProfile_id));
    }

    // Check if current page should have no menu highlighting
    const currentUrl = window.location.href;
    const shouldNotHighlight = currentUrl.includes('/account') || 
                              currentUrl.includes('/cart') || 
                              currentUrl === window.location.origin + '/' ||
                              currentUrl === window.location.origin + constants.ADDITIONAL_PATH ||
                              currentUrl === window.location.origin + constants.ADDITIONAL_PATH + '/';
    
    if (shouldNotHighlight) {
      setactiveMenuLink(null);
      setClickedMenuItem(null);
    } else {
      // Prioritize clicked menu item over URL-based matching
      if (clickedMenuItem) {
        setactiveMenuLink(clickedMenuItem);
      } else {
        const matchedItem = findMatchingSubmenu(
          headerResponseSuccess,
          activeMenuMatchUrl()
        );
        if (matchedItem !== null) {
          setactiveMenuLink(matchedItem);
        } else {
          setactiveMenuLink(null);
        }
      }
    }
  }, [userProfile_id, window.location.href, clickedMenuItem]);

  useEffect(() => {
    window.addEventListener("popstate", function () {
      config.logGeneral && console.log("button back called");
      setClickedMenuItem(null); // Reset clicked menu item on browser back/forward
      if (
        !window.location.href.includes("account") ||
        !window.location.href.includes("cart")
      ) {
        dispatch(clearAuthModalType());
      }
    });
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [navigate]);

  useEffect(() => {
    if (dailyMetalPriceSuccess?.data?.allMasterCountries?.nodes?.length > 0) {
      setOptions(dailyMetalPriceSuccess?.data?.allMasterCountries?.nodes);
      if (selectedcountrySuccess) {
        setSelectedOption(selectedcountrySuccess);
      } else if (selectedcountrySuccess === null) {
        let initialcountry =
          dailyMetalPriceSuccess?.data?.allMasterCountries?.nodes?.find(
            (e) => e.name === "INDIA"
          );
        setSelectedOption(initialcountry);
        dispatch(countryselect(initialcountry));
      }
    } else {
      selectedcountrySuccess ?? setSelectedOption(selectedcountrySuccess);
    }
  }, [dailyMetalPriceSuccess, selectedcountrySuccess]);
  useEffect(() => {
    dispatch(daily_metal_price_currency());
    dispatch(getHeaderdata());
    dispatch(getHomepagedata());
  }, []);
  useEffect(() => {
    if (persionalInformationDataSuccess) {
      var username =
        persionalInformationDataSuccess[1]?.value +
        " " +
        persionalInformationDataSuccess[2]?.value;
      //capitalizeFirstLetter
      var capitalizedString = username ? capitalizeFirstLetter(username) : "";
      setuserName(capitalizedString);
    }
  }, [persionalInformationDataSuccess]);

  // Dispatch action to close modal
  const handleCloseModal = () => {
    dispatch(loginModalAction({ isOpenModal: false, modalType: "" }));
  };
  const [isOpen, setIsOpen] = useState(false);
  const handleOptionClick = (option) => {
    dispatch(countryselect(option));
    setIsOpen(false);
  };
  const [activeMenu, setActiveMenu] = useState(null);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [leaveTimeout, setLeaveTimeout] = useState(null);
  const [isHoveringSubMenu, setIsHoveringSubMenu] = useState(false);
  const [isHoveringMainMenu, setIsHoveringMainMenu] = useState(false);

  let cartdetailsinLocalstorage = localStorage.getItem("cartDetails");
  let cartDetails = JSON.parse(cartdetailsinLocalstorage);
  const handleSearch = () => {
    if (searchQuery.trim()) {
      const results = []; // Example: fetchResults(searchQuery);
      setSearchResults(results);
      setIsModalOpen(true);
      setIsSearchOpen(false); // Close search bar
    }
  };
  const toggleSearchBar = () => {
    setIsSearchOpen((prevState) => !prevState);
  };
  const handleMouseEnter = (itemKey) => {
    setActiveMenu(itemKey);
    setIsHoveringMainMenu(true);
    setIsHoveringSubMenu(false);
    clearTimeout(leaveTimeout);
  };

  const handleMouseLeave = () => {
    config.logGeneral && console.log("Mouse left main menu");
    setIsHoveringMainMenu(false);
    setLeaveTimeout(
      setTimeout(() => {
        if (!isHoveringMainMenu && !isHoveringSubMenu) {
          setActiveMenu(null);
        }
      }, 300)
    ); // Delay of 300ms
  };

  const handleSubMenuMouseEnter = () => {
    setIsHoveringSubMenu(true);
    setIsHoveringMainMenu(true);
    clearTimeout(leaveTimeout);
  };

  const handleSubMenuMouseLeave = () => {
    config.logGeneral && console.log("Mouse left submenu");
    setIsHoveringSubMenu(false);
    setLeaveTimeout(
      setTimeout(() => {
        if (!isHoveringMainMenu && !isHoveringSubMenu) {
          setActiveMenu(null);
        }
      }, 300)
    ); // Delay of 300ms
  };

  const handleMenuWrapperMouseLeave = () => {
    setIsHoveringMainMenu(false);
    setIsHoveringSubMenu(false);
    setLeaveTimeout(
      setTimeout(() => {
        setActiveMenu(null);
      }, 300)
    ); // Delay of 300ms
  };

  useEffect(() => {
    dispatch(getHomepagenotification());
  }, []);

  // const notification = homeNotificationResponseSuccess || [];
  const notification =
    homeNotificationResponseSuccess?.props?.cardContent || [];
  const handleMobileSubmenu = (item) => {
    setActiveMenu(activeMenu === item.key ? null : item.key);
    if (!item?.Submenu) {
      navigate(constants.ADDITIONAL_PATH + `${item?.url}`);
      setIsNavOpen(false);
    }
  };

  const handlemobilesubmenutitle = (submenuItem) => {
    if (
      submenuItem.title != "FINISH AND DESIGN" &&
      submenuItem.title != "JEWEL TYPE" &&
      submenuItem.title != "PRICE RANGE"
    ) {
      navigate(constants.ADDITIONAL_PATH + `${submenuItem?.url}`);
      setIsNavOpen(false);
    } else {
      return;
    }
  };

  return (
    <>
      {/* Header Top Bar */}

      <div className="bg-[#06ab9f] text-center text-[#EFEBE8] uppercase font-bold py-2 flex items-center justify-center sticky w-full top-0 z-10">
        <Swiper
          slidesPerView={1}
          grid={{
            rows: 1,
          }}
          spaceBetween={0}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          modules={[Grid, Autoplay]}
          className="mySwiper"
        >
          {notification !== null &&
            notification?.length > 0 &&
            notification?.map((notification, index) => (
              <>
                <div className="">
                  <SwiperSlide
                    key={index}
                    className="flex-col relative slider-top"
                  >
                    <div className="flex gap-2">
                      <img
                        src={constants.DEFAULT_IMAGE + "/gift-top.svg"}
                        className="w-2 gift-img"
                      />
                      <h4 className="font-bold text-sm text-[#EFEBE8]">
                        {notification.text}
                      </h4>
                    </div>
                  </SwiperSlide>
                </div>
              </>
            ))}
        </Swiper>
      </div>

      {/* Menu */}
      <nav
        className="bg-white lg:p-2 p-1 w-full top-9 lg:h-[80px] h-[70px] sticky z-10"
        onMouseLeave={handleMenuWrapperMouseLeave}
      >
        <div className="container mx-auto flex items-center justify-between">
          <div className="flex items-center flex-shrink-0 text-black mr-6">
            {/* Logo */}

            <Link
              to="/"
              className="flex text-black no-underline hover:text-white hover:no-underline"
            >
              <span className="text-2xl pl-2 font-semibold">
                <img
                  src={constants.DEFAULT_IMAGE + "/logo.jpg"}
                  alt="Logo"
                  className="h-16 w-[162px]"
                />
              </span>
            </Link>
          </div>

          {/* Desktop navigation links */}
          <div
            className={`w-full flex-grow lg:flex lg:items-center lg:w-auto justify-center ${
              isNavOpen && !isSearchOpen ? "" : "hidden"
            } lg:block pt-6 lg:pt-0`}
            id="nav-content"
            onMouseLeave={handleMouseLeave}
          >
            {/* Main Menus */}
            {headerResponseSuccess?.map((item) => (
              <ul
                key={item.key}
                className="relative list-reset lg:block hidden"
                onMouseEnter={() => handleMouseEnter(item.key)}
                onMouseLeave={handleMouseLeave}
              >
                {/* Menu Title with Underline Animation */}
                <li className="relative">
                  <div
                    onClick={() => {
                      setClickedMenuItem(item?.title);
                      navigate(constants.ADDITIONAL_PATH + `${item?.url}`);
                      // window.location.replace(
                      //   constants.ADDITIONAL_PATH + `${item?.url}`
                      // );
                    }}
                    className={`cursor-pointer font-century inline-block py-2 px-[14px] font-medium no-underline relative
                     ${
                       activeMenuLink === item?.title
                         ? "bg-gradient-to-r from-[#007970] via-[#06AB9F] via-[#01998E] via-[#06AB9F] via-[#007970] to-[#06AB9F] bg-clip-text text-transparent"
                         : "text-[#383838]"
                     } after:content-[''] after:absolute after:left-[15px] after:bottom-0 after:w-1/2 after:h-[2px] after:bg-[#06ab9f] after:scale-x-0 after:transition-transform after:duration-300
                      hover:after:scale-x-100`}
                  >
                    {item?.title}
                  </div>
                </li>
              </ul>
            ))}
          </div>

          {/* Search and Icons */}

          <div className="flex text-[#1C1C1C] items-center space-x-4">
            <div className="flex items-center cursor-pointer">
              <Search
                wishlist={wishListDataSuccess?.length || 0}
                cart={
                  userProfile_id
                    ? cartItemsProductInfo
                    : cartDetails?.products.length
                }
              />

              {/* Country Select */}

              <div
                className="relative w-24 ml-5 hidden lg:block"
                onMouseLeave={() => setIsOpen(null)}
              >
                {/* Selected Option */}
                <div
                  onClick={() => setIsOpen(!isOpen)}
                  className="flex items-center justify-between p-2 border rounded-md cursor-pointer bg-[#242424] text-white"
                >
                  {selectedOption ? (
                    <div className="flex items-center text-xs">
                      <img
                        src={`${constants.imageCurrency}${selectedOption.iso}.png`}
                        alt={selectedOption.iso3}
                        className="mr-2"
                      />
                      {selectedOption.iso3}
                    </div>
                  ) : (
                    "Select"
                  )}
                  <span className="text-gray-500">
                    <img src={constants.DEFAULT_IMAGE + "/arrow-white.svg"} />
                  </span>
                </div>

                {/* Dropdown Menu */}
                {isOpen && (
                  <div className="absolute left-0 z-10 w-full mt-1 bg-[#242424] rounded-md shadow-md">
                    {options?.map(
                      (option) =>
                        option?.id !== selectedOption?.id && (
                          <div
                            key={option.id}
                            onClick={() => handleOptionClick(option)}
                            className="flex items-center p-3 cursor-pointer hover:bg-[#292929] text-white text-xs border-b-[#1E1E1E] rounded-md"
                          >
                            <img
                              src={`${constants.imageCurrency}${option.iso}.png`}
                              alt={option.label}
                              className="w-5 h-5 mr-2"
                            />
                            {option.iso3}
                          </div>
                        )
                    )}
                  </div>
                )}
              </div>

              {/* Menu Icon for Mobile Navigation */}

              <div className="">
                <button
                  className="lg:hidden px-4 py-2"
                  onClick={() => setIsNavOpen((prev) => !prev)}
                >
                  <svg
                    width="21"
                    height="16"
                    viewBox="0 0 21 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 15H19.6667M1 8H19.6667M1 1H19.6667"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>

            {/* For Open Search bar */}
            {isSearchOpen && (
              <div className="absolute top-3 bottom-0 left-1/4 right-1/2 m-auto w-[52%]">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search..."
                  className="w-full pl-12 pr-4 py-3 rounded-md focus:outline-none bg-[#F5F5F5] text-[#242424]"
                  autoFocus
                />
                <button
                  onClick={toggleSearchBar}
                  className="close-button absolute top-0 bottom-3 right-3"
                >
                  <img src={constants.DEFAULT_IMAGE + "/close.svg"} />
                </button>
                <img
                  src={constants.DEFAULT_IMAGE + "/searchicon.svg"}
                  onClick={handleSearch}
                  className="absolute left-0 right-0 top-0 ml-2 py-2 text-white rounded-md"
                />
              </div>
            )}
          </div>

          {/* Mobile */}
          {/* For Navbar/Sidabar Open */}
          {isNavOpen && (
            <div className="fixed inset-0 z-50">
              {/* Overlay */}
              <div
                className="absolute inset-0 bg-black bg-opacity-50"
                onClick={() => setIsNavOpen(false)}
              ></div>

              {/* Off-Canvas Menu */}
              <div
                className={`fixed top-0 right-0 h-full overflow-auto w-11/12 bg-white shadow-lg transform ${
                  isNavOpen ? "translate-x-0" : "-translate-x-full"
                } transition-transform duration-300`}
              >
                {/* Close Button */}
                <div className="flex items-end">
                  <img
                    src={constants.DEFAULT_IMAGE + "/navmenu-bg.jpg"}
                    className="relative flex justify-between items-center"
                  />
                  <div className="absolute flex w-full justify-between px-4 pb-4">
                    <div className="flex justify-start items-center">
                      <img src={constants.DEFAULT_IMAGE + "/myaccount.svg"} />
                      <div className=" pl-3 flex flex-col ">
                        {userProfile_id ? (
                          <span className="text-black font-semibold text-lg">
                            {userName}
                          </span>
                        ) : null}
                        <Link
                          to={constants.ADDITIONAL_PATH + "/account-profile"}
                          onClick={() => setIsNavOpen(false)}
                          className={`font-medium text-sm text-black underline ${
                            persionalInformationDataSuccess ? "-mt-2" : "mt-0"
                          }`}
                        >
                          {" "}
                          {userProfile_id ? "My Account " : " LogIn"}
                        </Link>
                      </div>
                    </div>
                    <button
                      className="text-gray-500 hover:text-black"
                      onClick={() => setIsNavOpen(false)}
                    >
                      <img
                        src={constants.DEFAULT_IMAGE + "/right-arrow.svg"}
                        alt="Right Arrow"
                      />
                    </button>
                  </div>
                </div>

                {/* Mobile Main Menu Listeeeeeeeeeee */}
                <ul className="pb-3 pt-2 ">
                  {headerResponseSuccessMobile.map((menuItem) => (
                    <li
                      key={menuItem.key}
                      className="mb-2 border border-t-0 border-l-0 border-r-0 border-b-[#C7F4F0]"
                    >
                      <div
                        className="text-[#262626] text-base font-medium py-2 px-4 flex justify-between items-center cursor-pointer"
                        onClick={() => {
                          setActiveMenu(
                            activeMenu === menuItem.key ? null : menuItem.key
                          );
                          if (menuItem.title === "Hot Sale") {
                            window.location.href =
                              constants.ADDITIONAL_PATH + menuItem.url;
                          }
                        }}
                      >
                        {menuItem.title}
                        {menuItem.Submenu && (
                          <svg
                            className={`transition-transform duration-300 ${
                              activeMenu === menuItem.key
                                ? "rotate-180"
                                : "rotate-0"
                            }`}
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M5 7.5L10 12.5L15 7.5"
                              stroke="#06ab9f"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        )}
                      </div>

                      {/* Submenu accordion */}
                      {activeMenu === menuItem.key && (
                        <ul className="transition-all duration-300 first:border-0">
                          {menuItem.Submenu?.flatMap((subArray, subIndex) =>
                            subArray.map((submenuItem, index) => (
                              <li
                                key={`submenu-${subIndex}-${index}`}
                                className=""
                              >
                                <div
                                  className="text-[#525252] text-xs font-medium leading-7 flex justify-between items-center cursor-pointer border border-b-0 border-l-0 border-r-0 border-t-[#EDEDED] pl-6 pr-5 py-2"
                                  onClick={() => {
                                    if (submenuItem.subitems?.length > 0) {
                                      setOpenSubmenu(
                                        openSubmenu === submenuItem.title
                                          ? null
                                          : submenuItem.title
                                      );
                                    } else {
                                      navigate(
                                        constants.ADDITIONAL_PATH +
                                          submenuItem.url
                                      );
                                      setIsNavOpen(false);
                                    }
                                  }}
                                >
                                  {submenuItem.title || submenuItem.value}
                                  {submenuItem.subitems && (
                                    <svg
                                      className={`transition-transform duration-300 ${
                                        openSubmenu === submenuItem.title
                                          ? "rotate-180"
                                          : "rotate-0"
                                      }`}
                                      width="16"
                                      height="16"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                    >
                                      <path
                                        d="M5 7.5L10 12.5L15 7.5"
                                        stroke="#06ab9f"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  )}
                                </div>

                                {/* Nested subitems (like Finish/Design -> CZ Jewellery etc) */}
                                {submenuItem.subitems &&
                                  openSubmenu === submenuItem.title && (
                                    <ul className="pl-6">
                                      {submenuItem.subitems.map(
                                        (subItem, subItemIndex) => (
                                          <li
                                            key={`subitem-${subItemIndex}`}
                                            className="text-[#242424] cursor-pointer font-medium text-sm leading-8"
                                            onClick={() => {
                                              navigate(
                                                constants.ADDITIONAL_PATH +
                                                  subItem.url
                                              );
                                              setIsNavOpen(false);
                                            }}
                                          >
                                            {subItem.value}
                                          </li>
                                        )
                                      )}
                                    </ul>
                                  )}
                              </li>
                            ))
                          )}
                        </ul>
                      )}
                    </li>
                  ))}
                  <Link
                    onClick={() => setIsNavOpen(false)}
                    to={constants.ADDITIONAL_PATH + "/account-wishlist"}
                  >
                    <li>
                      <p className="cursor-pointer py-2 px-4 text-[#383838] font-medium">
                        Wishlist
                      </p>
                    </li>
                  </Link>
                </ul>

                {/* Social Media Icons */}
                <div className="flex justify-between items-center bg-white w-full px-4 z-[1]">
                  <div className="flex justify-end items-center">
                    <Link
                      to="https://www.instagram.com/stylorisilver/?hl=en"
                      className="pr-2"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.87581 0.251852C10.4274 0.180424 10.9221 0.164551 14.8745 0.164551C18.8269 0.164551 19.3216 0.181747 20.8718 0.251852C22.4221 0.321958 23.4803 0.569313 24.4062 0.927778C25.3758 1.29418 26.2554 1.86693 26.9829 2.60767C27.7237 3.33386 28.2951 4.21217 28.6602 5.18307C29.02 6.109 29.266 7.1672 29.3374 8.71482C29.4089 10.269 29.4247 10.7638 29.4247 14.7148C29.4247 18.6672 29.4076 19.1619 29.3374 20.7135C29.2673 22.2611 29.02 23.3193 28.6602 24.2452C28.2951 25.2163 27.7227 26.096 26.9829 26.8233C26.2554 27.564 25.3758 28.1355 24.4062 28.5005C23.4803 28.8603 22.4221 29.1063 20.8745 29.1778C19.3216 29.2492 18.8269 29.2651 14.8745 29.2651C10.9221 29.2651 10.4274 29.2479 8.87581 29.1778C7.32819 29.1077 6.26999 28.8603 5.34406 28.5005C4.37306 28.1354 3.49329 27.563 2.76602 26.8233C2.02578 26.0967 1.45294 25.2173 1.08745 24.2466C0.728981 23.3206 0.482949 22.2624 0.41152 20.7148C0.340092 19.1606 0.324219 18.6659 0.324219 14.7148C0.324219 10.7624 0.341414 10.2677 0.41152 8.71746C0.481626 7.1672 0.728981 6.109 1.08745 5.18307C1.45348 4.21228 2.02676 3.33295 2.76734 2.60635C3.49358 1.86627 4.37246 1.29344 5.34274 0.927778C6.26866 0.569313 7.32686 0.323281 8.87448 0.251852H8.87581ZM20.7541 2.8709C19.2197 2.80079 18.7594 2.78624 14.8745 2.78624C10.9896 2.78624 10.5292 2.80079 8.99485 2.8709C7.57554 2.93571 6.8057 3.17249 6.29247 3.37222C5.6139 3.63677 5.12845 3.95027 4.61919 4.45952C4.13645 4.92917 3.76493 5.5009 3.53189 6.1328C3.33216 6.64603 3.09538 7.41587 3.03057 8.83519C2.96046 10.3696 2.94591 10.8299 2.94591 14.7148C2.94591 18.5997 2.96046 19.0601 3.03057 20.5944C3.09538 22.0138 3.33216 22.7836 3.53189 23.2968C3.76469 23.9278 4.13639 24.5005 4.61919 24.9701C5.08877 25.4529 5.66152 25.8246 6.29247 26.0574C6.8057 26.2571 7.57554 26.4939 8.99485 26.5587C10.5292 26.6288 10.9882 26.6434 14.8745 26.6434C18.7607 26.6434 19.2197 26.6288 20.7541 26.5587C22.1734 26.4939 22.9433 26.2571 23.4565 26.0574C24.1351 25.7929 24.6205 25.4794 25.1298 24.9701C25.6126 24.5005 25.9843 23.9278 26.2171 23.2968C26.4168 22.7836 26.6536 22.0138 26.7184 20.5944C26.7885 19.0601 26.8031 18.5997 26.8031 14.7148C26.8031 10.8299 26.7885 10.3696 26.7184 8.83519C26.6536 7.41587 26.4168 6.64603 26.2171 6.1328C25.9525 5.45423 25.639 4.96878 25.1298 4.45952C24.6601 3.97681 24.0884 3.60531 23.4565 3.37222C22.9433 3.17249 22.1734 2.93571 20.7541 2.8709ZM13.016 19.2003C14.0539 19.6323 15.2096 19.6906 16.2858 19.3652C17.3619 19.0399 18.2917 18.3509 18.9163 17.4162C19.5409 16.4814 19.8216 15.3588 19.7105 14.2401C19.5994 13.1213 19.1033 12.0759 18.307 11.2823C17.7994 10.775 17.1856 10.3865 16.5098 10.1449C15.8341 9.90328 15.1131 9.8145 14.3989 9.88494C13.6847 9.95539 12.9951 10.1833 12.3795 10.5523C11.764 10.9213 11.2379 11.4221 10.8392 12.0189C10.4404 12.6156 10.179 13.2932 10.0736 14.0031C9.96819 14.713 10.0215 15.4374 10.2297 16.1242C10.4379 16.811 10.7958 17.4431 11.2776 17.975C11.7594 18.5069 12.3531 18.9254 13.016 19.2003ZM9.58612 9.42646C10.2806 8.73198 11.1051 8.18109 12.0124 7.80524C12.9198 7.42939 13.8923 7.23594 14.8745 7.23594C15.8566 7.23594 16.8291 7.42939 17.7365 7.80524C18.6439 8.18109 19.4684 8.73198 20.1628 9.42646C20.8573 10.1209 21.4082 10.9454 21.7841 11.8528C22.1599 12.7602 22.3534 13.7327 22.3534 14.7148C22.3534 15.697 22.1599 16.6695 21.7841 17.5769C21.4082 18.4842 20.8573 19.3087 20.1628 20.0032C18.7603 21.4057 16.858 22.1937 14.8745 22.1937C12.891 22.1937 10.9887 21.4057 9.58612 20.0032C8.18356 18.6006 7.39561 16.6983 7.39561 14.7148C7.39561 12.7313 8.18356 10.829 9.58612 9.42646ZM24.0121 8.34974C24.1841 8.18739 24.3219 7.99217 24.4172 7.77563C24.5125 7.55908 24.5634 7.32562 24.5668 7.08906C24.5703 6.8525 24.5262 6.61766 24.4373 6.39843C24.3483 6.1792 24.2163 5.98004 24.049 5.81275C23.8817 5.64546 23.6826 5.51344 23.4634 5.42449C23.2441 5.33555 23.0093 5.2915 22.7727 5.29495C22.5362 5.2984 22.3027 5.34928 22.0862 5.44457C21.8696 5.53987 21.6744 5.67764 21.512 5.84974C21.1963 6.18443 21.0235 6.629 21.0302 7.08906C21.0369 7.54913 21.2226 7.98846 21.548 8.31381C21.8733 8.63916 22.3127 8.82491 22.7727 8.83161C23.2328 8.83832 23.6774 8.66546 24.0121 8.34974Z"
                          fill="black"
                        />
                      </svg>
                    </Link>
                    {/* <Link
                      to="https://x.com/StyloriSilver?t=FlKtk0ramMs7J6410Wu-gA&s=08"
                      className="px-2"
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_5691_9352)">
                          <path
                            d="M9.48008 8.70972L13.3057 14.1817H11.7357L8.61387 9.71656V9.71628L8.15555 9.0608L4.50879 3.84442H6.07883L9.02176 8.05424L9.48008 8.70972Z"
                            fill="black"
                          />
                          <path
                            d="M15.5747 0.5H2.24851C1.23405 0.5 0.411621 1.32243 0.411621 2.33689V15.6631C0.411621 16.6776 1.23405 17.5 2.24851 17.5H15.5747C16.5892 17.5 17.4116 16.6776 17.4116 15.6631V2.33689C17.4116 1.32243 16.5892 0.5 15.5747 0.5ZM11.2548 14.9163L8.0957 10.3187L4.14054 14.9163H3.11832L7.64182 9.65839L3.11832 3.07494H6.56848L9.55989 7.42857L13.3052 3.07494H14.3274L10.0139 8.08904H10.0136L14.7049 14.9163H11.2548Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_5691_9352">
                            <rect
                              width="17"
                              height="17"
                              fill="white"
                              transform="translate(0.411621 0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </Link> */}
                    <Link
                      to="https://www.facebook.com/stylori/"
                      className="px-2"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 38 38"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.9068 3.37305C10.4339 3.37305 3.56445 10.2425 3.56445 18.7154C3.56445 26.372 9.17419 32.7183 16.5101 33.8737V23.1514H12.6128V18.7154H16.5101V15.3352C16.5101 11.4869 18.801 9.36485 22.304 9.36485C23.9826 9.36485 25.741 9.66405 25.741 9.66405V13.4371H23.8015C21.8989 13.4371 21.3036 14.6217 21.3036 15.8354V18.7124H25.5554L24.8756 23.1483H21.3036V33.8706C28.6395 32.7214 34.2492 26.3736 34.2492 18.7154C34.2492 10.2425 27.3797 3.37305 18.9068 3.37305Z"
                          fill="black"
                        />
                      </svg>
                    </Link>
                    <Link
                      to="https://www.youtube.com/@Stylori"
                      className="px-2"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 41 44"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_2375_5523)">
                          <path
                            d="M40.1078 11.8323C39.8777 10.9603 39.4295 10.1707 38.8108 9.54769C38.1747 8.90547 37.395 8.44608 36.5454 8.21287C33.3658 7.3224 20.6267 7.3224 20.6267 7.3224C15.3159 7.2582 10.0065 7.54056 4.72829 8.1679C3.87867 8.41834 3.10046 8.88799 2.4629 9.5351C1.83644 10.1755 1.38268 10.9653 1.14565 11.8305C0.576239 15.0898 0.299581 18.3991 0.319404 21.7139C0.299087 25.0258 0.575066 28.334 1.14565 31.5973C1.37761 32.459 1.82967 33.2452 2.45782 33.8802C3.08597 34.5152 3.86819 34.9739 4.72829 35.2168C7.9503 36.1055 20.6267 36.1055 20.6267 36.1055C25.9442 36.1698 31.2605 35.8874 36.5454 35.26C37.395 35.0268 38.1747 34.5674 38.8108 33.9252C39.4293 33.3022 39.8769 32.5126 40.1061 31.6405C40.6903 28.3825 40.9744 25.0718 40.9543 21.7553C40.9983 18.4248 40.7145 15.0984 40.1078 11.8305V11.8323ZM16.5768 27.8735V15.5562L27.1757 21.7157L16.5768 27.8735Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_2375_5523">
                            <rect
                              width="40.6349"
                              height="43.1746"
                              fill="black"
                              transform="translate(0.318359 0.126953)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </Link>
                    {/* <Link
                      to="https://www.linkedin.com/company/stylori-silver/"
                      className="pl-2"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 32 31"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M2.22266 4.07958C2.22266 3.46057 2.46856 2.86692 2.90626 2.42921C3.34396 1.99151 3.93762 1.74561 4.55662 1.74561H27.8227C28.1294 1.74511 28.4333 1.80512 28.7168 1.9222C29.0003 2.03929 29.258 2.21114 29.475 2.42794C29.6921 2.64474 29.8642 2.90221 29.9816 3.18562C30.099 3.46903 30.1593 3.77281 30.1592 4.07958V27.3456C30.1595 27.6524 30.0993 27.9563 29.9821 28.2399C29.8649 28.5234 29.6929 28.781 29.476 28.9981C29.2591 29.2151 29.0016 29.3872 28.7181 29.5046C28.4346 29.622 28.1307 29.6823 27.8239 29.6821H4.55662C4.25002 29.6821 3.94641 29.6217 3.66316 29.5043C3.37991 29.387 3.12256 29.2149 2.90581 28.9981C2.68907 28.7812 2.51717 28.5238 2.39995 28.2404C2.28274 27.9571 2.22249 27.6535 2.22266 27.3469V4.07958ZM13.2804 12.397H17.0633V14.2967C17.6093 13.2047 19.0061 12.2218 21.1052 12.2218C25.1293 12.2218 26.083 14.397 26.083 18.3881V25.7812H22.0106V19.2974C22.0106 17.0243 21.4646 15.7418 20.0779 15.7418C18.1541 15.7418 17.3541 17.1247 17.3541 19.2974V25.7812H13.2804V12.397ZM6.29631 25.6072H10.37V12.2218H6.29631V25.6059V25.6072ZM10.9528 7.85608C10.9605 8.20487 10.8984 8.55169 10.7703 8.87617C10.6421 9.20065 10.4504 9.49626 10.2064 9.74565C9.96248 9.99504 9.67116 10.1932 9.34958 10.3285C9.028 10.4638 8.68264 10.5334 8.33377 10.5334C7.98489 10.5334 7.63953 10.4638 7.31795 10.3285C6.99637 10.1932 6.70505 9.99504 6.46109 9.74565C6.21713 9.49626 6.02544 9.20065 5.89727 8.87617C5.7691 8.55169 5.70704 8.20487 5.71472 7.85608C5.7298 7.17145 6.01235 6.51995 6.50188 6.04108C6.9914 5.56222 7.64897 5.29408 8.33377 5.29408C9.01856 5.29408 9.67613 5.56222 10.1657 6.04108C10.6552 6.51995 10.9377 7.17145 10.9528 7.85608Z"
                          fill="black"
                        />
                      </svg>
                    </Link> */}
                  </div>

                  {/* Country Select */}
                  <div
                    className="relative w-24 ml-5 lg:hidden block"
                    // onMouseLeave={() => setIsOpen(null)}
                  >
                    {/*MobileSelected Option */}
                    <div
                      onClick={() => {
                        setIsOpen(!isOpen);
                      }}
                      className="flex items-center justify-between p-2 border rounded-md cursor-pointer bg-[#242424] text-white"
                    >
                      {selectedOption ? (
                        <div className="flex items-center text-xs">
                          <img
                            src={`${constants.imageCurrency}${selectedOption.iso}.png`}
                            alt={selectedOption.iso3}
                            className="mr-2"
                          />
                          {selectedOption.iso3}
                        </div>
                      ) : (
                        "Select"
                      )}
                      <span className="text-gray-500">
                        <img
                          src={constants.DEFAULT_IMAGE + "/arrow-white.svg"}
                        />
                      </span>
                    </div>

                    {/* Mobile Dropdown Menu */}
                    {isOpen && (
                      <div className="absolute left-0 z-10 w-full mt-1 bg-black rounded-md shadow-md top-auto bottom-full">
                        {options?.map(
                          (option) =>
                            option?.id !== selectedOption?.id && (
                              <div
                                key={option.id}
                                onClick={() => {
                                  handleOptionClick(option);
                                  setIsNavOpen(false);
                                  window.scrollTo(0, 0);
                                }}
                                className="flex items-center p-3 cursor-pointer hover:bg-[#292929] text-white text-xs border-b-[#1E1E1E] rounded-md"
                              >
                                <img
                                  src={`${constants.imageCurrency}${option.iso}.png`}
                                  alt={option.label}
                                  className="w-5 h-5 mr-2"
                                />
                                {option.iso3}
                              </div>
                            )
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Modal for Search Results */}
          {isModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-start justify-center">
              <div className="bg-white w-11/12 md:w-2/3 p-6 rounded-md shadow-lg mt-32">
                <h2 className="text-lg font-medium mb-4 uppercase">
                  Suggestions
                </h2>
                <hr className="border-[#06ab9f] border"></hr>
                <div className="flex flex-wrap gap-3 pt-5 pb-3">
                  <div className="flex border w-auto rounded-full py-1 px-2">
                    <img
                      src={constants.DEFAULT_IMAGE + "/sparkling.svg"}
                      className="pr-1"
                    />
                    <p className="text-base font-medium text-[#262626]">
                      Pendants
                    </p>
                  </div>
                  <div className="flex border w-auto rounded-full py-1 px-2">
                    <img
                      src={constants.DEFAULT_IMAGE + "/sparkling.svg"}
                      className="pr-1"
                    />
                    <p className="text-base font-medium text-[#262626]">
                      Earrings
                    </p>
                  </div>
                  <div className="flex border w-auto rounded-full py-1 px-2">
                    <img
                      src={constants.DEFAULT_IMAGE + "/sparkling.svg"}
                      className="pr-1"
                    />
                    <p className="text-base font-medium text-[#262626]">
                      Rings
                    </p>
                  </div>
                  <div className="flex border w-auto rounded-full py-1 px-2">
                    <img
                      src={constants.DEFAULT_IMAGE + "/sparkling.svg"}
                      className="pr-1"
                    />
                    <p className="text-base font-medium text-[#262626]">
                      Bangles
                    </p>
                  </div>
                  <div className="flex border w-auto rounded-full py-1 px-2">
                    <img
                      src={constants.DEFAULT_IMAGE + "/sparkling.svg"}
                      className="pr-1"
                    />
                    <p className="text-base font-medium text-[#262626]">
                      Bracelets
                    </p>
                  </div>
                  <div className="flex border w-auto rounded-full py-1 px-2">
                    <img
                      src={constants.DEFAULT_IMAGE + "/sparkling.svg"}
                      className="pr-1"
                    />
                    <p className="text-base font-medium text-[#262626]">
                      Nosepins
                    </p>
                  </div>
                  <div className="flex border w-auto rounded-full py-1 px-2">
                    <img
                      src={constants.DEFAULT_IMAGE + "/sparkling.svg"}
                      className="pr-1"
                    />
                    <p className="text-base font-medium text-[#262626]">Kada</p>
                  </div>
                  <div className="flex border w-auto rounded-full py-1 px-2">
                    <img
                      src={constants.DEFAULT_IMAGE + "/sparkling.svg"}
                      className="pr-1"
                    />
                    <p className="text-base font-medium text-[#262626]">
                      Bridal Accessories
                    </p>
                  </div>
                  <div className="flex border w-auto rounded-full py-1 px-2">
                    <img
                      src={constants.DEFAULT_IMAGE + "/sparkling.svg"}
                      className="pr-1"
                    />
                    <p className="text-base font-medium text-[#262626]">
                      Short Necklace
                    </p>
                  </div>
                  <div className="flex border w-auto rounded-full py-1 px-2">
                    <img
                      src={constants.DEFAULT_IMAGE + "/sparkling.svg"}
                      className="pr-1"
                    />
                    <p className="text-base font-medium text-[#262626]">
                      Long Necklace
                    </p>
                  </div>
                  <div className="flex border w-auto rounded-full py-1 px-2">
                    <img
                      src={constants.DEFAULT_IMAGE + "/sparkling.svg"}
                      className="pr-1"
                    />
                    <p className="text-base font-medium text-[#262626]">
                      Idols
                    </p>
                  </div>
                  <div className="flex border w-auto rounded-full py-1 px-2">
                    <img
                      src={constants.DEFAULT_IMAGE + "/sparkling.svg"}
                      className="pr-1"
                    />
                    <p className="text-base font-medium text-[#262626]">
                      Anklet
                    </p>
                  </div>
                </div>
                <h2 className="text-lg font-medium mb-4 uppercase pt-5">
                  Products
                </h2>
                <hr className="border-[#06ab9f] border"></hr>
                <button
                  className="absolute top-2 right-2 text-gray-600"
                  onClick={() => setIsModalOpen(false)}
                >
                  &times;
                </button>
                {searchResults.length ? (
                  <ul>
                    {searchResults.map((result, index) => (
                      <li key={index} className="py-2">
                        {result.title}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <div className="grid grid-cols-4 gap-3 pt-5">
                    <div className="flex col-span-1 items-center gap-2">
                      <img
                        src={constants.DEFAULT_IMAGE + "/kundan.jpg"}
                        className="size-16"
                      />
                      <div className="">
                        <h3 className="text-[#242424] text-sm font-semibold pb-1">
                          Kundan earrings
                        </h3>
                        <p className="text-[#6A6A6A] text-xs font-medium">
                          ₹ 5,800
                        </p>
                      </div>
                    </div>
                    <div className="flex col-span-1 items-center gap-2">
                      <img
                        src={constants.DEFAULT_IMAGE + "/pichwai.jpg"}
                        className="size-16"
                      />
                      <div className="">
                        <h3 className="text-[#242424] text-sm font-semibold pb-1">
                          Muhali Pichwai Earrings
                        </h3>
                        <p className="text-[#6A6A6A] text-xs font-medium">
                          ₹ 5,800
                        </p>
                      </div>
                    </div>
                    <div className="flex col-span-1 items-center gap-2">
                      <img
                        src={constants.DEFAULT_IMAGE + "/varshin.jpg"}
                        className="size-16"
                      />
                      <div className="">
                        <h3 className="text-[#242424] text-sm font-semibold pb-1">
                          Varshin Earrings
                        </h3>
                        <p className="text-[#6A6A6A] text-xs font-medium">
                          ₹ 9,300
                        </p>
                      </div>
                    </div>
                    <div className="flex col-span-1 items-center gap-2">
                      <img
                        src={constants.DEFAULT_IMAGE + "/kundan.jpg"}
                        className="size-16"
                      />
                      <div className="">
                        <h3 className="text-[#242424] text-sm font-semibold pb-1">
                          Nikitha Krish Earrings
                        </h3>
                        <p className="text-[#6A6A6A] text-xs font-medium">
                          ₹ 9,300
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Sub Menus */}
          {!isSearchOpen &&
            headerResponseSuccess?.map((item) => {
              // Calculate total submenu items
              const submenuItemCount = item?.Submenu?.reduce(
                (count, subArray) => count + subArray.length,
                0
              );

              return (
                <>
                  {/* Dropdown Submenu */}
                  {submenuItemCount && activeMenu === item.key && (
                    <div
                        className={`absolute top-full bg-white shadow-lg z-50 rounded-b-3xl sm:hidden lg:block
                          ${item?.Submenu?.length >= 4
                            ? "w-auto max-w-screen-lg left-[20%]"
                            : item?.Submenu?.length === 3
                            ? "w-full max-w-[750px] left-[27%]"
                            : "w-full max-w-[550px] left-[27%]"
                          }
                        `}
                        onMouseEnter={handleSubMenuMouseEnter}
                        onMouseLeave={handleSubMenuMouseLeave}
                        style={
                          submenuItemCount > 11
                            ? {}
                            : {
                                left:
                                  item?.title === "Style"
                                    ? "56%"
                                    : item?.title === "Hot Sale"
                                    ? "56.5%"
                                    : item?.title === "Wedding Ensemble"
                                    ? "27%"
                                    : "58%",
                                transform: "inherit",
                                width: item?.Submenu?.length <= 2 ? "200px" : undefined, // Even smaller for 1–2 items
                              }
                        }
                      >

                      {submenuItemCount > 11 ? (
                        /* Mega Menu Layout */
                        <div
                          onMouseLeave={() => setActiveMenu(null)}
                          className="container mx-auto py-6 lg:flex gap-3 px-5 justify-items-center shadow-lg hidden "
                        >
                          {item?.Submenu?.map((subArray, subIndex) => {
                            const columnCount = item.Submenu.length;

                            // Calculate width class
                            let widthClass = "w-full"; // fallback
                            if (columnCount === 4) widthClass = "w-1/4";
                            else if (columnCount === 3) widthClass = "w-1/3";
                            else if (columnCount === 2) widthClass = "w-1/2";
                            else widthClass = "w-full";

                            return (
                              <ul
                                key={subIndex}
                                className={`py-2 first:px-5 ${widthClass}`}
                              >
                                {subArray.map((necklace, index) => (
                                  <li
                                    key={index}
                                    className={`menu-head block px-1 py-1 text-sm text-gray-700 ${
                                      subIndex === 0 ? "pb-0" : ""
                                    }`}
                                  >
                                    {/* First Column: Full Content */}
                                    {subIndex === 0 &&
                                    item.title !== "Others Categories" ? (
                                      <>
                                        <h3 className="font-tiemann font-normal tracking-widest text-lg text-black pb-4">
                                          {necklace.title}
                                        </h3>
                                        <p className="text-xs text-[#636363] font-medium pb-3">
                                          {necklace.description && (
                                            <span>{necklace.description}</span>
                                          )}
                                        </p>
                                        <img
                                          src={necklace.img}
                                          alt={necklace.title}
                                          className="pb-5"
                                        />
                                        <button
                                          className="bg-[#06ab9f] px-3 py-2 text-white"
                                          onClick={() => {
                                            navigate(
                                              constants.ADDITIONAL_PATH +
                                                necklace.button_url
                                            );
                                            setActiveMenu(null);
                                          }}
                                        >
                                          {necklace.button}
                                        </button>
                                      </>
                                    ) : (
                                      <>
                                      
                                        <h3
                                          className="text-sm font-semibold tracking-widest cursor-pointer text-black"
                                          onClick={() => {
                                            window.location.href =
                                              constants.ADDITIONAL_PATH +
                                              necklace.url;
                                          }}
                                        >
                                          {necklace.title}
                                        </h3>
                                        <p
                                          className="text-[#242424] cursor-pointer text-sm font-medium"
                                          onClick={() => {
                                            window.location.href =
                                              constants.ADDITIONAL_PATH +
                                              necklace.url;
                                          }}
                                        >
                                          {necklace.value}
                                        </p>
                                      </>
                                    )}
                                  </li>
                                ))}
                              </ul>
                            );
                          })}
                        </div>
                      ) : (
                        /* Normal Dropdown Layout */
                        <ul
                          onMouseLeave={() => setActiveMenu(null)}
                          className="py-2 hidden lg:block"
                        >
                          {item?.Submenu?.flat().map((necklace, index) => (
                            <li
                              key={index}
                              className="menu-head block px-4 py-1"
                            >
                              <h3
                                className="text-sm font-semibold text-black uppercase tracking-widest"
                                // onClick={() => {
                                //   window.location.href =
                                //     constants.ADDITIONAL_PATH +
                                //     "/silver-jewellery?sort=New%20to%20Stylori&startprice=0&endprice=0";
                                // }}
                              >
                                {necklace.title}
                              </h3>
                              <p
                                className="text-[#242424] text-sm cursor-pointer font-medium pb-0"
                                onClick={() => {
                                  window.location.href =
                                    constants.ADDITIONAL_PATH + necklace.url;
                                }}
                              >
                                {necklace.value}
                              </p>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  )}
                </>
              );
            })}
        </div>
      </nav>
      <Modal onClose={handleCloseModal} addtocartapi={null} />
      <PopupModal isOpen={authModalopen} page="loginmodal">
        <Authenticatemodal
          closebtn={
            window.location.href.includes("account") ||
            window.location.href.includes("cart")
              ? true
              : false
          }
        />
      </PopupModal>
      <SeoHelmet />
    </>
  );
};

export default Header;
